var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsBoolean, IsOptional, IsString } from 'class-validator';
import { IsValidBillingCode } from '../validators/abrechnungscode.js';
import { IsValidIk } from '../validators/institutionskennzeichen.js';
/**
 * Body for `PATCH /office-locations/:officeLocationId/leistungserbringer/:id`.
 *
 * The Heilmittelbereich is not editable: it is half the aggregate's key, and
 * moving a Leistungserbringer between Bereiche would almost always mean the IK
 * is wrong too. Delete and re-create instead.
 */
export class UpdateLeistungserbringerDto {
    ik;
    billingCode;
    /** The §302 participation switch (#1513). Omitted means "leave it alone". */
    participatesInGkvBilling;
}
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    IsValidIk(),
    __metadata("design:type", String)
], UpdateLeistungserbringerDto.prototype, "ik", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    IsValidBillingCode(),
    __metadata("design:type", String)
], UpdateLeistungserbringerDto.prototype, "billingCode", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateLeistungserbringerDto.prototype, "participatesInGkvBilling", void 0);
//# sourceMappingURL=update-leistungserbringer.dto.js.map